// extracted by mini-css-extract-plugin
module.exports = {"assign-topic-modal":"MobileChatActions_assign-topic-modal__2Iv-D","assign-topic-heading-container":"MobileChatActions_assign-topic-heading-container__39gEa"};